<!--
  Full view of the Provisionsmatrix (cp.ProvisionTypeMatrix) — the wide variant of the one shared
  overview component. Shape of cp-provision-contract-agent-full.component.html.
-->
@if (navigationItems && initialized) {

    <div class="cp-provision-type-matrix-full mt-4">

        <cp-provision-type-matrix-overview
                [provisionTypeMatrixId]="objectIdentifier.objectId"
                [compact]="false">
        </cp-provision-type-matrix-overview>

    </div>

}
